import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const fetchAnswerBookletInDetail = createAsyncThunk(
    "answerBookletInDetail/fetchAnswerBookletInDetail",
    async (
        { valuatorCode, examinationCode, qpCode, valuationTypeCode },
        { rejectWithValue },
    ) => {
        try {
            const response = await api.get(
                `/v1/Valuator/${valuatorCode}/${examinationCode}/${qpCode}/${valuationTypeCode}/valuation`,
            );

            return response.data.data;
        } catch (error) {
            return rejectWithValue({
    message: error.response?.data?.Message || error.message,
    status: error.response?.status,
  });
        }
    },
);

const AnswerBookletInDetailSlice = createSlice({
    name: "AnswerBookletInDetailSlice",
    initialState: {
        data: null,
        loading: false,
        error: null,
        currentRequestId: null,
    },
      reducers: {
    clearAnswerBookletInDetail: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.currentRequestId = null;
    },
  },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAnswerBookletInDetail.pending, (state, action) => {
                state.loading = true;
                state.error = null;
                state.data = null;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(fetchAnswerBookletInDetail.fulfilled, (state, action) => {
                if (state.currentRequestId !== action.meta.requestId) return;
                state.loading = false;
                state.data = action.payload;
                state.currentRequestId = null;
            })
            .addCase(fetchAnswerBookletInDetail.rejected, (state, action) => {
                if (state.currentRequestId !== action.meta.requestId) return;
                state.loading = false;
                state.error = action.payload;
                state.data = null;
                state.currentRequestId = null;
            });
    },
});
export const { clearAnswerBookletInDetail } =
  AnswerBookletInDetailSlice.actions;
export default AnswerBookletInDetailSlice.reducer;
